import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5500;
const INTERVAL = 15000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setMinutesAgo(1 + Math.floor(Math.random() * 12));
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-48" data-mp="115uxoi1fmkw4">
      <AnimatePresence data-id="element-49" data-mp="1fxvdfmg5xbs5">
        {open && !dismissed && <motion.div key={`${buyer.name}-${index}`} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(15,74,58,0.35)] ring-1 ring-ink/10 sm:w-[340px]" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-50" data-mp="1axqvdrzlw8zt">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-brand-light text-2xl" aria-hidden="true" data-id="element-51" data-mp="28jeu4jjjb3ei">
              {buyer.flag}
            </span>
            <div className="min-w-0" data-id="element-52" data-mp="2ap30va5akqb6">
              <p className="text-sm font-bold text-ink" data-id="element-53" data-mp="2ao1lwul5njo6">
                {buyer.name} <span className="font-normal text-ink/70" data-id="element-54" data-mp="2fmv1qtnwzmri">from {buyer.country}</span>
              </p>
              <p className="text-[13px] text-ink/75" data-id="element-55" data-mp="2kmhc8vccyowm">just bought the Reflexology Session Blueprint™ digital book</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-brand" data-id="element-56" data-mp="2pkj0duon5eey">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-57" data-mp="1rzej6iqgb6dr" />
                {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink/50 transition-colors duration-150 hover:bg-ink/5 hover:text-ink" aria-label="Close notification" data-id="element-58" data-mp="21w9hp1mq56s1">
              <XIcon className="h-4 w-4" data-id="element-59" data-mp="195rd1w6cqxci" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}